import { I18n, Translate } from "react-redux-i18n";
import { CAMPAIGN_ACTIONS, CAMPAIGN_STATUS } from "assets/js/const/Campaign";
import { getCalendarFormat, getTimeDifference } from "utils/dateTimeUtils";
import fetchRoute from "utils/routes";
import React from "react";
import store from "../store";
import { DialogHandler } from "cakemail-ui-components/lib/react";
import { getBrandDialogIntro } from "assets/js/scenes/brand/utils";
import { sendZendeskRequestService } from "assets/js/services/hiddenService";
import { getListService } from "../services/listService";
import { isPartnerOrOrganization } from "./apiUtils";

const sortAlphabetically = (arr, order) => {
	if (arr) {
		return arr.sort(function (a, b) {
			var textA = a.name.toUpperCase();
			var textB = b.name.toUpperCase();
			return textA < textB ? -1 : textA > textB ? 1 : 0;
		});
	}
	return arr;
};

const getCampaignProgress = (
	campaign,
	date,
	unBlockedDomains,
	scheduleDataValid,
	totalSteps = 6
) => {
	if (campaign) {
		let total = 0;

		if (campaign.status !== CAMPAIGN_STATUS.INCOMPLETE) return 100;

		if (campaign.audience.list_id) total++;
		//if (campaign.name && campaign.name !== I18n.t("app-campaigns-flow-step1-subject-untitled" )) total++;
		if (campaign.sender.email) total++;
		if (
			campaign.sender.name &&
			campaign.sender.name !==
			I18n._translate("app-campaign-steps-overview-sender_unknown")
		) {
			total++;
		}
		if (
			campaign.content.subject &&
			campaign.content.subject !==
			I18n._translate("app-campaign-steps-overview-subject_empty")
		)
			total++;
		if (campaign.content.html || campaign.content.json) total++;
		if (date && scheduleDataValid) total++;

		return (total * 100) / totalSteps;
	} else {
		return 0;
	}
};

function getSegmentIdFromName(segment) {
	if (segment && segment.includes("multisublist_")) {
		let ids = segment.split("_");
		ids.splice(0, 2);
		ids.pop();
		ids = ids.map((id) => {
			if (isNaN(id)) {
				return id;
			}
			return parseInt(id);
		});
		return ids;
	}
	return [];
}

function getCampaignListSegmentInfo(
	campaign,
	campaignReport,
	campaignSegment,
	campaignList,
	customDateObject = null
) {
	let segmentElement = null;
	if (campaignSegment) {
		segmentElement = (
			<>
				{campaignSegment.length}{" "}
				{campaignSegment.length > 1 ? (
					// If campaignSegment length is greater than 0
					<Translate className={"test"} value={"app-general-segment-plurial"} />
				) : (
					<Translate className={"test"} value={"app-general-segment"} />
				)}
				{": "}
				{campaignSegment.map((segment, index) => (
					<>{segment}
						{index !== campaignSegment.length - 1 ? ", " : ""}
					</>
				))}
			</>
		);
	}

	return (
		<>
			<div className="line">
				{customDateObject ? (
					customDateObject
				) : (
					<>
						{campaign?.status !== "incomplete" ? (
							<Translate value="app-general-sent" />
						) : (
							<Translate value="app-general-date-created" />
						)}{" "}
						{getCalendarFormat(
							campaign.scheduled_for
								? campaign.scheduled_for
								: campaign.created_on
						)}
						{getTimeDifference(campaign.scheduled_for ? campaign.scheduled_for : campaign.created_on)}
					</>
				)}{" "}
				{campaignReport?.sent_emails && (
					<>
						<Translate value="app-general-to" /> {campaignReport?.sent_emails}{" "}
						{campaignReport?.sent_emails > 1 ? (
							<Translate value="app-campaigns-flow-overview-to-subscribers" />
						) : (
							<Translate value="app-campaigns-flow-overview-to-subscriber" />
						)}
					</>
				)}
			</div>
			<span className="line">
				<a
					href={`#${fetchRoute("contacts")}?listId=${campaign.audience.list_id
						}`}
				>
					{campaign.audience?.name
						? campaign.audience.name
						: campaignList?.name}
				</a>
				<br />
				{segmentElement}
			</span>
		</>
	);
}
function getCampaignListingInfoStructure(
	campaign,
	campaignReport,
	campaignSegment,
	campaignList,
	customDateObject = null
) {
	let segmentIds = [];
	let segmentElement = null;
	if (campaignSegment?.name) {
		segmentIds = getSegmentIdFromName(campaignSegment?.name);

		if (segmentIds.length > 0) {
			segmentElement = (
				<>
					{segmentIds.length}{" "}
					<Translate className={"test"} value={"app-general-segment-plurial"} />
				</>
			);
		} else {
			segmentElement = (
				<>
					1 <Translate value="app-general-segment" />
				</>
			);
		}
	}

	const activeEmails = campaignReport?.report?.sent_emails || campaignReport?.report?.active_emails;

	return (
		<>
			{customDateObject ? (
				customDateObject
			) : (
				<>
					{campaign?.status !== "incomplete" ? (
						<Translate value="app-general-sent" />
					) : (
						<Translate value="app-general-date-created" />
					)}{" "}
					{getCalendarFormat(
						campaign.scheduled_for
							? campaign.scheduled_for
							: campaign.created_on
					)}
				</>
			)}{" "}
			{activeEmails && (
				<span className="toHide">
					<Translate value="app-general-to" /> {activeEmails}{" "}
					{activeEmails > 1 ? (
						<Translate value="app-campaigns-flow-overview-to-subscribers" />
					) : (
						<Translate value="app-campaigns-flow-overview-to-subscriber" />
					)}
				</span>
			)}
			<br />
			<span className="line">
				<a
					className={segmentElement ? "list" : ""}
					onClick={(e) => handleClick(e, campaign.audience.list_id)}
				>
					{campaign.audience?.name
						? campaign.audience.name
						: campaignList?.name}
				</a>{" "}
				{""}
				{segmentElement}
			</span>
		</>
	);
} const handleClick = (event, list_id) => {
	getListService(
		{ id: parseInt(list_id) },
		(data) => {
			window.location.href = `#${fetchRoute("contacts")}?listId=${list_id}`;
		},
		() => {
			DialogHandler.show({
				type: "error",
				title: (
					<Translate value="app-list-access-error" />
				),
			});
		}
	);
};

function loadImage(url) {
	return new Promise((resolve, reject) => {
		let img = document.createElement("img");
		img.src = url;
		img.onload = () => {
			resolve();
		};
		img.onerror = () => {
			reject();
		};
	});
}

export function base64Encode(s) {
	const trimmedString = s.trim();
	return btoa(trimmedString);
}

export function base64Decode(s) {
	return atob(s);
}

export function isBase64Encoded(str) {
	const base64Regex =
		/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
	return base64Regex.test(str);
}

export function replaceInvalidInterestChar(value) {
	return value.replace(/[^A-Za-z0-9\-+_@]+/g, "_");
}

export function checkBrandRepo(extraKey = null) {
	const userBrand = store.getState().userBrand;
	let data = {
		hasBrandRepo: true,
		mapKey: extraKey
	};

	if (userBrand == null) return data;

	if (extraKey && userBrand[extraKey]) {
		genericRecursiveTraversal(userBrand[extraKey], (obj, key, value) => {
			if (typeof value !== "object" && value && !data.hasMinMapping) {
				data.hasMinMapping = true;
			}
		});
	}

	return data;
}

export function genericRecursiveTraversal(obj, stopCondition, parentKeys = []) {
	//console.log("in", parentKeys);
	for (var key in obj) {
		if (typeof obj[key] === "object") {
			genericRecursiveTraversal(obj[key], stopCondition, parentKeys.concat(key));
		}
		if (stopCondition(obj, key, obj[key], parentKeys.concat(key))) {
			return true;
		}
	}
}

export function getNestedProperty(obj, path) {
	// Split the path into an array of properties
	const properties = path.split('.');

	// Traverse the object
	let current = obj;
	for (const prop of properties) {
		// Check if the property exists
		if (current && prop in current) {
			current = current[prop];
		} else {
			// Property not found, return undefined
			return undefined;
		}
	}

	// Return the final value
	return current;
}

export function findNestedProperty(obj, key) {
	if (obj === null || typeof obj !== 'object') {
		return undefined;
	}

	if (obj.hasOwnProperty(key)) {
		return obj[key];
	}

	for (let k in obj) {
		if (obj.hasOwnProperty(k)) {
			let result = findNestedProperty(obj[k], key);
			if (result !== undefined) {
				return result;
			}
		}
	}

	return undefined;
}

export function findAllNestedProperties(obj, key) {
	let results = [];

	function findNestedProperty(obj, key) {
		if (obj === null || typeof obj !== 'object') {
			return;
		}

		if (obj.hasOwnProperty(key)) {
			results.push(obj[key]);
		}

		for (let k in obj) {
			if (obj.hasOwnProperty(k)) {
				findNestedProperty(obj[k], key);
			}
		}
	}

	findNestedProperty(obj, key);
	return results;
}

export function initiateSmartEmailDialog(btnRef, history) {
	let brandRepoStatus = checkBrandRepo("smart_email_templates");

	if (!brandRepoStatus.hasMinMapping) {
		let link = {};
		link.localRedirect = fetchRoute("brand") + "?tab=SmartEmailTemplates";
		DialogHandler.show(getBrandDialogIntro("smart_email_templates", link, history));

		setTimeout(() => { if (btnRef) btnRef.reset(); }, 500);
		return true;
	}

	return false;
}

export function getParentFromLineage(cLineage) {
	const lineage = cLineage || store.getState().global.account.lineage;
	const split = lineage.split("-");
	const parent = split[split.length - 2];
	return parent || "0";
}


export function handleActionBlocked(action = CAMPAIGN_ACTIONS.SCHEDULE, btnRef = null, history) {
	let buttonLink = fetchRoute("profile");

	let title = I18n.t("app-campaign-schedule-blocked-dialog-title");
	let content = I18n.t("app-campaign-schedule-blocked-dialog-content");
	let buttonText = I18n.t("app-campaign-schedule-blocked-dialog-button");

	if (action == CAMPAIGN_ACTIONS.TEST) {
		title = I18n.t("app-campaign-test-blocked-dialog-title");
		content = I18n.t("app-campaign-test-blocked-dialog-content");
		buttonText = I18n.t("app-campaign-test-blocked-dialog-button");
	} else if (action == CAMPAIGN_ACTIONS.TRIGGER) {
		title = I18n.t("app-automation-test-blocked-dialog-title");
		content = I18n.t("app-campaign-test-blocked-dialog-content");
		buttonText = I18n.t("app-campaign-test-blocked-dialog-button");
	}

	let account = store.getState().global.account;
	let user = store.getState().global.user;
	let resellerName = store.getState().brand?.name;

	// open zendesk ticket if account profile is already complete
	if (
		account.name &&
		account.address.address1 &&
		account.address.city &&
		account.address.country
	) {
		buttonLink = null;
		buttonText = I18n.t("app-general-close");
		content = I18n.t(
			"app-campaign-schedule-blocked-profile-complete-dialog-content"
		);

		let inductionFormKey = isPartnerOrOrganization()
			? "app-induction-form-resellers"
			: "app-induction-form";

		sendZendeskRequestService({
			content: {
				type: "induction",
				subject: I18n.t("app-induction-form-subject", {
					resellerName: resellerName,
				}),
				message: I18n.t(inductionFormKey, {
					resellerName: resellerName,
					accountId: account.id,
					companyName: account.name,
					userFirstName: user.first_name,
					userLastName: user.last_name,
					userEmail: user.email,
				}),
			},
		});
	}

	// avoid showing the same dialog multiple times when multiple tests were blocked
	if (
		DialogHandler.isShowing() &&
		DialogHandler.currentDialog.state.title == title
	) {
		return;
	}

	DialogHandler.show({
		title: title,
		content: content,
		type: "warning",
		primaryBtnText: buttonText,
		primaryBtnOnClick: () => {
			DialogHandler.hide();

			if (btnRef) {
				btnRef.reset();
			}

			if (buttonLink && history) {
				history.push(buttonLink);
			}
		},
	});
}

export function formatNumber(number, options = {}) {
	try {
		const local = store.getState().global.language?.replace("_", "-");
		return new Intl.NumberFormat(local || "en-US", options).format(
			number,
		);
	} catch (e) {
		return number;
	}
}

export function removeNullProperties(obj, removeEmptyString = false) {
	for (let key in obj) {
		if (obj[key] && typeof obj[key] === 'object') {
			removeNullProperties(obj[key], removeEmptyString);
		} else if (obj[key] === null || (removeEmptyString && obj[key] === "")) {
			delete obj[key];
		}
	}
}


export {
	loadImage,
	sortAlphabetically,
	getCampaignProgress,
	getSegmentIdFromName,
	getCampaignListingInfoStructure,
	getCampaignListSegmentInfo,
};
